import { ApiResponse } from 'apisauce';

import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import {
  HomeownerAudienceFilterOptionsModel,
  HomeownerAudienceModel,
  HomeownerAudienceResponseModel,
  HomeownerAudienceSearchModel
} from '../shared/models/homeowner-audience.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'MARKETING_MODULE';

export function getHomeownerAudience(
  query: HomeownerAudienceSearchModel
): Promise<HomeownerAudienceModel | ErrorInfo> {
  return api
    .getHomeownerAudience(query)
    .then((response: ApiResponse<HomeownerAudienceResponseModel, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return {
            rows: data.data,
            count: data.count || 0
          };
        }

        return errorHelper(0, '', MODULE_NAME, (api.getHomeownerAudience as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getHomeownerAudience as any).displayName
      );
    });
}

/**
 * The export comes back as a CSV body, not JSON, so the raw payload is returned for the caller to
 * turn into a download. A failure still arrives as JSON, which is why the ok check comes first.
 */
export function exportHomeownerAudience(
  query: HomeownerAudienceSearchModel
): Promise<Blob | string | ErrorInfo> {
  return api.exportHomeownerAudience(query).then((response: ApiResponse<any, ErrorInfo>) => {
    if (response.ok && response.data) {
      return response.data as Blob | string;
    }

    return errorHelper(
      Number(response.status),
      response.data && response.data.errorCode
        ? String(response.data.errorCode || '')
        : String(response.problem || ''),
      MODULE_NAME,
      (api.exportHomeownerAudience as any).displayName
    );
  });
}

export function getHomeownerAudienceFilterOptions(): Promise<
  HomeownerAudienceFilterOptionsModel | ErrorInfo
> {
  return api
    .getHomeownerAudienceFilterOptions()
    .then(
      (response: ApiResponse<ResponseModel<HomeownerAudienceFilterOptionsModel>, ErrorInfo>) => {
        if (response.ok) {
          const { data } = response;
          if (data && data.data) {
            return data.data;
          }

          return errorHelper(
            0,
            '',
            MODULE_NAME,
            (api.getHomeownerAudienceFilterOptions as any).displayName
          );
        }

        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          MODULE_NAME,
          (api.getHomeownerAudienceFilterOptions as any).displayName
        );
      }
    );
}
